import { render, staticRenderFns } from "./CompanyLicence.vue?vue&type=template&id=6a5b162e&scoped=true"
import script from "./CompanyLicence.vue?vue&type=script&lang=js"
export * from "./CompanyLicence.vue?vue&type=script&lang=js"
import style0 from "./CompanyLicence.vue?vue&type=style&index=0&id=6a5b162e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b162e",
  null
  
)

export default component.exports